@if (tripTypeListChips().length > 0) {
<section class="register-user__trip-types-field">
  <header class="trip-types-field__header">
    <h3 class="trip-types-field__title ci-heading-h2-s-bold">
      {{ 'Tipo de viajero' | translate }}
    </h3>
    
    @if(isInvalidField()) {
      <mat-error class="ci-paragraph-p1-regular">
        {{ 'Tipo de viajero es obligatorio' | translate }}
      </mat-error>
    } @else { 
      <span class="ci-paragraph-p1-regular trip-types-field__helper-text">
        <span>{{ 'Selecciona un tipo de viajero' | translate }} 
          <strong> ({{ 'obligatorio' | translate }})</strong>
        </span>
      </span>
    }
  </header>

  <main>
    <ci-chip-set (change)="handleChipSetTripTypeChange($event)">
      @for(tripType of tripTypeListChips(); track tripType.id) {
        <ci-filter-chip-outline
          class="register-user__chip-trip-type"
          [chip]="tripType"
          [attr.icon-name]="tripType?.iconName"
          [value]="tripType.id"
          [attr.data-selected]="isSelectedTripType(tripType.id)"
          [selected]="isSelectedTripType(tripType.id)"
        >
          <span slot="label">
            {{ tripType.label }}
          </span>
        </ci-filter-chip-outline>
      }
    </ci-chip-set>
  </main>
</section>
}